import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    templateUrl: './unsupported-browser.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class UnsupportedBrowserComponent implements OnInit {

    constructor(private router: Router, private route: ActivatedRoute) { }

    ngOnInit(): void {
    }
}
